import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {OrgantraegerDetailKapGAus} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'kapgaus-organschaftsverhaeltnisse-form',
    templateUrl: './kapgaus-organschaftsverhaeltnisse-form.component.html',
    styleUrls: ['./kapgaus-organschaftsverhaeltnisse-form.component.scss']
})
export class KapgAusOrganschaftsverhaeltnisseFormComponent extends FormBaseComponent<OrgantraegerDetailKapGAus> implements OnInit {

    @Input()
    public organtraegerDetail: OrgantraegerDetailKapGAus;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                private readonly cd: ChangeDetectorRef,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    ngOnInit(): void {
        this.data = this.organtraegerDetail;
        if (this.data.isKStUndGewStOrgangesellschaft === undefined) {
            this.data.isKStUndGewStOrgangesellschaft = false;
        }
        if (this.data.isUStOrgantraegerIdentisch === undefined) {
            this.data.isUStOrgantraegerIdentisch = false;
        }
        if (this.data.isUmsatzsteuerOrgangesellschaft === undefined) {
            this.data.isUmsatzsteuerOrgangesellschaft = false;
        }
        if (!this.data.steuernummerKSt) {
            this.data.steuernummerKSt = {};
        }
        if (!this.data.steuernummerUSt) {
            this.data.steuernummerUSt = {};
        }
        super.ngOnInit();
    }

    showUStBereich(): boolean {
        return this.data.isUStOrgantraegerIdentisch || this.data.isUmsatzsteuerOrgangesellschaft;
    }

    onKStCheckboxChange(): void {
        if (!this.data.isKStUndGewStOrgangesellschaft) {
            this.data.nameOrgantraegerKSt = null;
            this.data.steuernummerKSt = {};
            this.data.wirtschaftsIdNummerKSt = null;
            this.data.datumGewinnAbfVertrag = null;
            this.form.patchValue({
                nameOrgantraegerKSt: null,
                datumGewinnAbfVertrag: null
            });
        }
        this.cd.detectChanges();
    }

    onUStIdentischCheckboxChange(): void {
        if (!this.showUStBereich()) {
            this.clearUStFields();
        }
        this.cd.detectChanges();
    }

    onUStOrgangesellschaftCheckboxChange(): void {
        if (!this.showUStBereich()) {
            this.clearUStFields();
        }
        this.cd.detectChanges();
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            isKStUndGewStOrgangesellschaft: [this.data.isKStUndGewStOrgangesellschaft, []],
            nameOrgantraegerKSt: [this.data.nameOrgantraegerKSt, []],
            datumGewinnAbfVertrag: [this.data.datumGewinnAbfVertrag, []],
            isUStOrgantraegerIdentisch: [this.data.isUStOrgantraegerIdentisch, []],
            isUmsatzsteuerOrgangesellschaft: [this.data.isUmsatzsteuerOrgangesellschaft, []],
            nameOrgantraegerUSt: [this.data.nameOrgantraegerUSt, []],
            ustIdentifikationsnummer: [this.data.ustIdentifikationsnummer, [
                this.validatorService.pattern(ValidationPattern.UST_ID,
                    this.translateService.instant('COMMON_UI.VALIDATION.UST_IDENTIFIKATION_NUMMER'))
            ]],
            beginnUStOrganschaft: [this.data.beginnUStOrganschaft, []]
        });
    }

    private clearUStFields(): void {
        this.data.nameOrgantraegerUSt = null;
        this.data.steuernummerUSt = {};
        this.data.ustIdentifikationsnummer = null;
        this.data.wirtschaftsIdNummerUSt = null;
        this.data.beginnUStOrganschaft = null;
        this.form.patchValue({
            nameOrgantraegerUSt: null,
            ustIdentifikationsnummer: null,
            beginnUStOrganschaft: null
        });
    }
}

